import {
  OpenPositionsListItem,
  OpenPositionsListItemProps,
} from './OpenPositionsListItem';

export type OpenPositionsListProps = {
  items: OpenPositionsListItemProps[];
};

export function OpenPositionsList({ items }: OpenPositionsListProps) {
  return (
    <ul className='dark:border-gray-dark-600 w-full border-t border-gray-200'>
      {items.map((item) => (
        <li
          key={item.title}
          className='dark:border-gray-dark-600 border-b border-gray-200'
        >
          <OpenPositionsListItem {...item} />
        </li>
      ))}
    </ul>
  );
}
